module.exports = __webpack_public_path__ + "img/fi2x-6-460x295.8df8d8c8.jpg";